import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';

import { Observable, of } from 'rxjs';
import * as fromMeteringPointStore from '@appStore/metering-points';
import * as fromMeteringPointReducers from '@appStore/metering-points/reducers';
import * as fromCustomersStore from '@appStore/customers';
import * as fromCustomersReducers from '@appStore/customers/reducers';
import * as fromAccountStore from '@appStore/account';
import { filter, take } from 'rxjs/operators';

@Injectable()
export class MeteringPointsGuard  {
  constructor(private store: Store<fromMeteringPointStore.State>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    let id = route.params['mpId'];
    this.store
      .select(fromMeteringPointReducers.getMeteringPointsLoaded)
      .pipe(
        filter(x => !x),
        take(1)
      )
      .subscribe(x => {
        this.store.dispatch(new fromMeteringPointStore.LoadMeteringPoints());
      });

    this.store
      .select(fromMeteringPointStore.getMeteringPointsLoaded)
      .pipe(
        filter(x => !!x),
        take(1)
      )
      .subscribe(x => {
        // MeteringPoints must be loaded before LoadDisruptions can be dispatched
        let fromDate = localStorage.getItem('sxFakeDate') ? new Date(localStorage.getItem('sxFakeDate')) : new Date();
        this.store.dispatch(new fromMeteringPointStore.LoadMeteringPointsDisruptions({fromDate : fromDate}));
      });

    this.store
      .select(fromCustomersReducers.getCustomersLoaded)
      .pipe(
        filter(x => !x),
        take(1)
      )
      .subscribe(x => {
        this.store.dispatch(new fromCustomersStore.CustomersLoadData());
      });

     // Ensure External Organisations
    this.store
      .select(fromCustomersReducers.getExternalOrganisationsLoaded)
      .pipe(
        filter(x => !x),
        take(1)
      )
        .subscribe(x => {
          this.store.dispatch(new fromCustomersStore.CustomersExternalOrganisationsLoadData());
    });

    this.store
      .select(fromMeteringPointReducers.getMeteringPointGroupsLoaded)
      .pipe(
        filter(x => !x),
        take(1)
      )
      .subscribe(x => {
        this.store.dispatch(new fromMeteringPointStore.LoadMeteringPointGroups());
      });

    this.store
      .select(fromAccountStore.getSettingsLoaded)
      .pipe(
        filter(x => !x),
        take(1)
      )
      .subscribe(x => {
        this.store.dispatch(new fromAccountStore.SettingLoad());
      });

    return of(true);
  }
}
